import { render, staticRenderFns } from "./StartApply.vue?vue&type=template&id=58faaa52&scoped=true"
import script from "./StartApply.vue?vue&type=script&lang=js"
export * from "./StartApply.vue?vue&type=script&lang=js"
import style0 from "./StartApply.vue?vue&type=style&index=0&id=58faaa52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58faaa52",
  null
  
)

export default component.exports